module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABWElEQVRYR+2WzZGCQBCFe9Saq16s4mgIG4IbiZqBP3GoawYYyZqBZiFVZoDiWIygKDPMvNYqPMgRmH4f/fNoQTVfomZ9+gJ8dgbieTCUsyh8pU/iZfcnPS8nh50pjjUD8SIIicSAlArlLBpxILS4av3rs+L0a4IwAqhl0DueaUdCtPVhBkRBvJPBr+R0P37+EHsGUvpzc8OBKIurtZxGQ6gE6cs6EAiBiOvKuGqLQKDiXgC+meCIewO4ILjiEIANghrJKhu1rNvtDQc3oelAqSceXsLE4QzkWmYIXPw1gKvD5SbDMisWgMHh7kVgOKbTB4olNnU7ieQPNatiTG+AqlFDzMr7X+D68mdv50I4M4CYDAeiEgARt46oozGrf8cPo+Y/50gm7AuJEtv7nPuLV5gVuJDkKxnh4iWI9EYj6XuvZLcAdS6lrkXlXc+dY/guIVucL0DtGbgA8CAWMENGCF4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/closeMenu.png
// module id = Pp6S
// module chunks = 8